<template>
  <div class="facetrange mt-4" v-if="this.facet">

    <label class="facetlabel">{{$t('scifund.labels.'+facetname)}}</label>
    <div class="maxh">
    <b-list-group >
      <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="filter in facet.groupedCounts" :key="filter.value" href="#" v-on:click.prevent="facetChanged" v-bind:data-actionurl="filter.sem_action.sem_url_action">

        <span v-if="facetname == 'Budget_Total'"> {{formatBudget(filter.value)}}</span>
        <span v-else-if="facetname == 'Publication_Date'">{{formatPublicationDate(filter.value)}}</span>
        <span v-else>{{filter.value}}</span>
        <b-badge variant="light" pill>{{filter.count}}</b-badge>
      </b-list-group-item>
    </b-list-group>
    </div>
  </div>
</template>

<script>


export default {
  name: 'facetrange',
  props: [ 'facet', 'facetname' ],
  methods: {
    facetChanged: function (e) {
      this.$router.push(e.srcElement.getAttribute('data-actionurl'));
    },
    formatPublicationDate: function (v) {
      if( v && v.startsWith("*")) {
        return v.substr(0,9);
      } else {
        return v.substr(0, 4);
      }
    },
    formatBudget: function (v) {
      return v.replaceAll(/(\d+)(0{6})\b/g, "$1M");
    }
  }
}
</script>

<style scoped>
  .facetrange {
    margin-bottom: 10px;
  }

  .x {
    padding: 0px 20px;
  }
  .facetlabel {
    font-size: 14px;
    color: #888;
    font-weight: 700;
  }
  .maxh {
    max-height: 290px;
    overflow: scroll;
  }
</style>
